export default __webpack_public_path__ + "static/media/aimeme.c8f08bda.png";